import 'react-app-polyfill/stable';

import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import '@okta/okta-auth-js/polyfill';
import setupStore from './store/setupStore';
import App from './App';
import * as serviceWorker from './registerServiceWorker';
import * as jquery from "jquery";
import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';
import { Grommet, Box, Layer, Spinner, Image } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

Object.assign(global, {
    $: jquery,
    jQuery: jquery
});

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = setupStore(history);
const persistor = persistStore(store);

class FallbackLoading extends React.Component {
    render() {
        return <Grommet theme={hpe}>
            <Layer>
                <Box pad="small">
                    <Image src="images/loader.svg" />
                </Box>
            </Layer>
        </Grommet>;
    }
}

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <ClearBrowserCacheBoundary auto fallback={<FallbackLoading />} duration={10000} filename={`${process.env.REACT_APP_SITE_DIR}meta.json`}>
                {/* <PersistGate loading={null} persistor={persistor}> */}
                <App />
                {/* </PersistGate> */}
            </ClearBrowserCacheBoundary>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));

serviceWorker.unregister();
